module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_13.85b49888.png";